var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('top-bar'),_c('div',{staticClass:"d-flex"},[_c('side-bar'),_c('b-container',{attrs:{"fluid":"","id":"content"}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }